import React from 'react';
import { CoreContainer } from '@hub/core-container';
import { DEFAULT_BREAKPOINT, useBreakpointValue } from '@hub/design-system-base';
import { Link } from '@hub/link';
import { CloudinaryImage, IMAGE_SIZES_FULL_WIDTH } from '../cloudinary-image';
import { jsx as _jsx } from "react/jsx-runtime";
export const Banner = _ref => {
  var _useBreakpointValue;

  let {
    url,
    image,
    onClick,
    mobileImage,
    as,
    gutter
  } = _ref;
  const isMobile = (_useBreakpointValue = useBreakpointValue([true, false, false], DEFAULT_BREAKPOINT)) !== null && _useBreakpointValue !== void 0 ? _useBreakpointValue : false;
  const [bestImage, ratio] = getImageAndRatio(isMobile, image, mobileImage);
  return /*#__PURE__*/_jsx(CoreContainer, {
    isMobileFullWidth: true,
    gutter: gutter,
    sx: {
      textAlign: '-webkit-center'
    },
    as: as,
    "data-id": "banner_index_Banner_CoreContainer",
    children: /*#__PURE__*/_jsx(Link, {
      href: url,
      onClick: onClick,
      "data-id": "banner_index_Banner_CoreContainer_Link",
      children: /*#__PURE__*/_jsx(CloudinaryImage, {
        imageSetOrImage: bestImage,
        ratio: ratio,
        resizeMode: "crop-center",
        sizes: IMAGE_SIZES_FULL_WIDTH,
        "data-id": "banner_index_Banner_Link_CloudinaryImage"
      })
    })
  });
};

function getImageAndRatio(isMobile, image, mobileImage) {
  const ratio = isMobile && !mobileImage ? '3/2' : ['3/2', '4.6/1'];
  const bestImage = getBestImage(isMobile, image, mobileImage);
  return [bestImage, ratio];
}

function getBestImage(isMobile, image, mobileImage) {
  if (!mobileImage) {
    return image;
  }

  return isMobile ? mobileImage : image;
}